<h2 class="SummaryTitle">{{ 'app.view.editor-properties-view-component.settings' | translate }}</h2>
<sbb-accordion [multi]="true">
  <sbb-expansion-panel [expanded]="true">
    <sbb-expansion-panel-header>{{ 'app.view.editor-properties-view-component.color-scheme' | translate }}</sbb-expansion-panel-header>
    <sbb-label>{{ 'app.view.editor-properties-view-component.theme' | translate }}</sbb-label>
    <br/>
    <sbb-radio-group
      [(ngModel)]="activeColorTheme.themeRegistration"
      class="sbb-radio-group-vertical"
    >
      <sbb-radio-button
        *ngFor="let option of colorThemeOptions"
        [value]="option.themeRegistration"
        (change)="onUpdateColorTheme($event)"
      >
        {{ option.name }}
      </sbb-radio-button>
    </sbb-radio-group>

    <br/>
    <ng-container *ngIf="!isActiveColorThemeDark()">
      <sbb-label>{{ 'app.view.editor-properties-view-component.background-color' | translate }}</sbb-label>
      <input
        id="activeBackgroundColor"
        type="color"
        sbbInput
        [name]="'app.view.editor-properties-view-component.background-color' | translate"
        style="width: 242px; min-height: 37px"
        [(ngModel)]="activeBackgroundColor"
        (change)="colorPicked($event)"
      />
      &nbsp;
      <button
        sbb-secondary-button
        style="vertical-align: middle;"
        [disabled]="isBackgroundColorWhite()"
        [title]="'app.view.editor-properties-view-component.set-color-to-white' | translate"
        (click)="setBackgroundColorToWhite()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fit=""
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
        >
          <polygon
            fill="white"
            stroke="#000"
            points="5.5 18.5 18.5 18.5 18.5 5.5 5.5 5.5"
          ></polygon>
        </svg>
      </button>
      &nbsp;
      <button
        sbb-secondary-button
        [disabled]="isDefaultBackgroundColorActive()"
        style="vertical-align: middle;"
        [title]="'app.view.editor-properties-view-component.reset-background-color-to-default' | translate"
        (click)="onResetBackgroundColor()"
      >
        <sbb-icon svgIcon="trash-small"></sbb-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="isActiveColorThemeDark()">
      <sbb-label>{{ 'app.view.editor-properties-view-component.background-color-black' | translate }}</sbb-label>
      <br/>
      <input
        id="activeDarkBackgroundColor"
        type="color"
        sbbInput
        [name]="'app.view.editor-properties-view-component.background-color' | translate"
        style="width: 242px; min-height: 37px; vertical-align: middle;"
        [(ngModel)]="activeDarkBackgroundColor"
        (change)="colorPicked($event)"
      />
      &nbsp;
      <button
        sbb-secondary-button
        [disabled]="isDefaultDarkBackgroundColorActive()"
        [title]="'app.view.editor-properties-view-component.reset-background-color-to-default' | translate"
        style="vertical-align: middle;"
        (click)="onResetDarkBackgroundColor()"
      >
        <sbb-icon svgIcon="trash-small"></sbb-icon>
      </button>
    </ng-container>
    <br/>
    <ng-container *ngIf="isLocalStoredColorTheme()">
      <button
        sbb-secondary-button
        class="sbb-mt-m"
        [title]="'app.view.editor-properties-view-component.useDefaultBrowserColorTheme' | translate"
        (click)="resetLocalStoredColorData()"
      >
        {{ 'app.view.editor-properties-view-component.defaultBrowserColorTheme' | translate }}
      </button>
    </ng-container>
  </sbb-expansion-panel>


  <sbb-expansion-panel [expanded]="true">
    <sbb-expansion-panel-header>{{ 'app.view.editor-properties-view-component.editor' | translate }}</sbb-expansion-panel-header>
    <sbb-label>{{ 'app.view.editor-properties-view-component.travel-time-presetting-default' | translate }}</sbb-label>
    <br/>
    <sbb-radio-group
      [(ngModel)]="activeTravelTimeCreationEstimatorType"
      class="sbb-radio-group-vertical"
    >
      <sbb-radio-button
        *ngFor="let option of travelTimeCreationEstimatorTypeOptions"
        [value]="option.travelTimeCreationEstimatorType"
        [title]="option.title"
        (change)="onUpdateaTravelTimeCreationEstimatorType($event)"
      >
        {{ option.name }}
      </sbb-radio-button>
    </sbb-radio-group>
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="true">
    <sbb-expansion-panel-header>{{ 'app.view.editor-properties-view-component.graphicTimetable' | translate }}</sbb-expansion-panel-header>
    <sbb-label>{{ 'app.view.editor-properties-view-component.axis-scaling-distance' | translate }}</sbb-label>
    <br/>
    <sbb-radio-group
      [(ngModel)]="activeStreckengrafikRenderingType"
      class="sbb-radio-group-vertical"
    >
      <sbb-radio-button
        *ngFor="let option of streckengrafikRenderingTypeOptions"
        [value]="option.streckengrafikRenderingType"
        [title]="option.title"
        (change)="onUpdateStreckengrafikRenderingType($event)"
      >
        {{ option.name }}
      </sbb-radio-button>
    </sbb-radio-group>
  </sbb-expansion-panel>

</sbb-accordion>
